module.exports = __webpack_public_path__ + "img/7.39fc44a4.png";